import React from 'react'
import PropTypes from 'prop-types'

const Finished = props => {
  return (
    <div className="maxw-600px mx-auto text-center">
      <h4>All Finished!</h4>
      <p>
        You have successfully connected your MyEducator courseware with Canvas!
        Students will be able to access MyEducator and any assessments you
        imported directly through Canvas and grades will be reported back
        automagically.
      </p>
      <a
        className="btn btn-success btn-lg"
        href={`/instructor/setup/${props.coursenum}`}
      >
        Exit
      </a>
    </div>
  )
}

Finished.propTypes = {
  coursenum: PropTypes.string.isRequired,
}

export default Finished
